import { Outlet, useLocation } from 'react-router-dom';

import NoActiveOrganizationState from '../ui/NoActiveOrganizationState';
import { useTenantGuard } from '../../hooks/useTenantGuard';
import { requiresTenantContext } from '../../utils/tenantRoutes';

/** Outlet با مسدودسازی سراسری برای کاربران tenant بدون سازمان فعال */
export default function TenantAwareOutlet() {
  const location = useLocation();
  const { blocked } = useTenantGuard();

  if (blocked && requiresTenantContext(location.pathname)) {
    return <NoActiveOrganizationState />;
  }

  return <Outlet key={location.pathname} />;
}
